// extracted by mini-css-extract-plugin
export default {"space":"TenantDetail_space__r4-Jp"};